import { Component, OnInit, ViewChild} from '@angular/core';
import { UIRouter, Transition } from "@uirouter/angular";
import { DatepickerComponent } from '../datepicker/datepicker.component';
import { TimepickerComponent } from '../timepicker/timepicker.component';

import { AuditTrailService } from "../audit-trail-service/audit-trail.service"
import { ClientConfigService } from "../client-config-service/client-config.service"
import { CustomerService } from "../customer-service/customer.service"

@Component({
  selector: 'app-audit-trail-overlay',
  templateUrl: './audit-trail-overlay.component.html',
  styleUrls: ['./audit-trail-overlay.component.less']
})
export class AuditTrailOverlayComponent implements OnInit {

	@ViewChild('reminderForm') reminderForm;

  private categories:any = [
  	{
  		name:'Email'
  	},
    {
      name:'Facebook'
    },
    {
      name:'Internal'
    },
    {
      name:'Introducer'
    },
  	{
  		name:'Letter'
  	},
  	{
  		name:'Live Chat'
  	},
  	{
  		name:'Meeting'
  	},
    {
      name:'Messenger'
    },
    {
      name:'Phone'
    },
    {
      name:'Tweet'
    },
  	{
  		name:'Other'
  	}
  ];
  
  private admins = [];

  reminder: any = {
  	admins:[],
  	date:''
  }

  datesValid: any = {};

  addValid:any = true;
  reminderDateLabel:string = 'Reminder Date';
  reminderTimeLabel:string = 'Reminder Time';
  reminderType:string = 'reminder';
  dateLabel:string = 'Date';
  timeLabel:string = 'Time';
  private clientConfig:any
  //private maxDate:any
  private customerPolicies:any


  constructor(private router: UIRouter, 
              private auditTrailService: AuditTrailService,
              private clientConfigService: ClientConfigService,
              private customerService: CustomerService) {

                //this.maxDate = {year: 2018, month: 1, day: 30};

               }

  ngOnInit() {
  	
    this.clientConfigService.retrieveClientConfig()

        this.clientConfigService.clientConfig.subscribe((x)=>{
      
          this.clientConfig = x

          this.admins = [];
          this.clientConfig.admins.forEach(function(element){

            this.admins.push({id:element.id,name:element.firstname+' '+element.surname})

          },this);

        })


    this.customerService.retrieveCustomerPolicies(this.router.globals.params.customerId);

    this.customerService.policies.subscribe((x)=>{
          
      this.customerPolicies = x


    })


  }

  hideOverlay() {
    this.router.stateService.go('app.customerAudit')

  }

  adminChange(id,check){
  	if(check){
  		if(!this.reminder.admins.includes(id)){
  			this.reminder.admins.push(id);
  		}
  	}else{
  		var index = this.reminder.admins.indexOf(id);
		if (index != -1) {
		   this.reminder.admins.splice(index, 1);
		}
  	}
  }

  dateChange({date,type,req}){

  	if(date){
  		this.reminder[type] = date.year+'-'+date.month+'-'+date.day;
  		if(req == true){
  			this.datesValid[type] = true;
  		}
  	}else{
  		this.reminder[type] = '';
  		if(req == false){
  			this.datesValid[type] = true;
  		}else{
  			this.datesValid[type] = false;
  		}
  	}
	for (var i in this.datesValid) {
	    if (this.datesValid[i] === false) {
	        this.addValid = false;
	        break;
	    }else{
	    	this.addValid = true;
	    }
	}
  }

  timeChange({time,type}){
  	this.reminder[type] = time;
  }

  taskChange(checked){
    if(checked == true){
      this.reminder.createTask = true;
    }
  }

  submitAuditTrailInternalItem(item){

    console.log(item,'Item in submitAuditTrailInternalItem')

    this.auditTrailService.insertAuditTrailInternalNote({
      customer:this.router.globals.params.customerId,
      message:item.message,
      category:item.category,
      detail:item.detail,
      sanctionsCheck:item.sanctions,
      fraudSuspicion:item.fraud,
      reminders:item.admins,
      reminderDate:item.reminderDate+' '+item.reminderTime,
      messageDateTime:item.date+' '+item.time,
      task:item.taskAdmin,
      policy:item.policy
    });

    this.hideOverlay();

  }

}



// WEBPACK FOOTER //
// /Users/mattspringbett/sites/cycler/apollo-admin/src/src/app/audit-trail-overlay/audit-trail-overlay.component.ts